import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardFirstBadge = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 45,
  viewBox: "0 0 28 45",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("circle", {
    cx: 14,
    cy: 19.5,
    r: 12,
    fill: "#274A34"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#274A34",
    d: "M23.276 41.88c.311 1.557-1.23 2.84-2.704 2.25l-5.829-2.332a2 2 0 0 0-1.486 0l-5.829 2.331c-1.475.59-3.015-.691-2.704-2.249l1.796-8.979c.135-.679.904-1.019 1.53-.724A13.95 13.95 0 0 0 14 33.5c2.127 0 4.144-.475 5.95-1.324.625-.295 1.394.045 1.53.724z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#CCF88E",
    d: "m11.153 15.532 4.144-1.552V25.5h-2.512v-8.112l-1.632.656z"
  })]
});
export default SvgLeaderboardFirstBadge;